// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add Currency Pair Page */
.addpair-page .dashboard-body {
  width: 100%;
  max-width: 680px;
}

.addpair-hero__icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  font-size: 1.35rem;
  color: #fff;
}

.addpair-body {
  padding-bottom: 2rem;
}

.addpair-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 3rem;
  color: var(--text-muted);
  font-size: 0.95rem;
}

.addpair-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--border);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 1.5rem;
}

.addpair-stepper {
  margin-bottom: 1.5rem;
}

.addpair-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.addpair-alert {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-radius: 10px;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.addpair-alert--error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.addpair-config-grid {
  display: grid;
  /* grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); */
  gap: 1rem 1.25rem;
}

.addpair-config-grid .cp-input-wrap {
  min-width: 0;
}

.addpair-summary {
  background: #f8fafc;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  border: 1px solid var(--border);
}

.addpair-summary-row {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  font-size: 0.9rem;
}

.addpair-summary-row span {
  color: var(--text-muted);
}

.addpair-actions {
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
}

.addpair-actions .cp-btn--outline {
  margin-right: auto;
}

.addpair-success-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.addpair-success-modal {
  background: #fff;
  border-radius: 12px;
  padding: 1.75rem;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  text-align: center;
}

.addpair-success-icon {
  font-size: 3rem;
  color: #16a34a;
  margin-bottom: 0.75rem;
}

.addpair-success-modal h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text);
}

.addpair-success-modal p {
  margin: 0 0 1.25rem 0;
  font-size: 0.95rem;
  color: var(--text-muted);
}

.addpair-success-details {
  text-align: left;
  background: #f8fafc;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  margin-bottom: 1.25rem;
  border: 1px solid var(--border);
}

.addpair-success-row {
  display: flex;
  justify-content: space-between;
  padding: 0.4rem 0;
  font-size: 0.9rem;
}

.addpair-success-row span {
  color: var(--text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Trading/AddCurrencyPairPage.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* Add Currency Pair Page */\n.addpair-page .dashboard-body {\n  width: 100%;\n  max-width: 680px;\n}\n\n.addpair-hero__icon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 12px;\n  font-size: 1.35rem;\n  color: #fff;\n}\n\n.addpair-body {\n  padding-bottom: 2rem;\n}\n\n.addpair-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 3rem;\n  color: var(--text-muted);\n  font-size: 0.95rem;\n}\n\n.addpair-card {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  padding: 1.5rem;\n}\n\n.addpair-stepper {\n  margin-bottom: 1.5rem;\n}\n\n.addpair-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.addpair-alert {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n}\n\n.addpair-alert--error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.addpair-config-grid {\n  display: grid;\n  /* grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); */\n  gap: 1rem 1.25rem;\n}\n\n.addpair-config-grid .cp-input-wrap {\n  min-width: 0;\n}\n\n.addpair-summary {\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 1rem 1.25rem;\n  border: 1px solid var(--border);\n}\n\n.addpair-summary-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5rem 0;\n  font-size: 0.9rem;\n}\n\n.addpair-summary-row span {\n  color: var(--text-muted);\n}\n\n.addpair-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n.addpair-actions .cp-btn--outline {\n  margin-right: auto;\n}\n\n.addpair-success-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.addpair-success-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.75rem;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  text-align: center;\n}\n\n.addpair-success-icon {\n  font-size: 3rem;\n  color: #16a34a;\n  margin-bottom: 0.75rem;\n}\n\n.addpair-success-modal h3 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.addpair-success-modal p {\n  margin: 0 0 1.25rem 0;\n  font-size: 0.95rem;\n  color: var(--text-muted);\n}\n\n.addpair-success-details {\n  text-align: left;\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 1rem 1.25rem;\n  margin-bottom: 1.25rem;\n  border: 1px solid var(--border);\n}\n\n.addpair-success-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.4rem 0;\n  font-size: 0.9rem;\n}\n\n.addpair-success-row span {\n  color: var(--text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
